<template>
<div class="chapter">
<div class="inner_page">
<div> <a id="list0"></a></div>
<p class="center"><img alt="" height="550" src="html/docimages/image1.jpg" width="345"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005_map.vue?e3f03298